
export const Impressum = () => (
  <div className="doc-container">
    <h2>Legal notice</h2>
    <h3>Website Operator:</h3>
    <p>
      Medical University of Innsbruck <br/>
      Institute of humangenetics<br/>
      Biochemical genetics<br/>
      Peter-Mayr-Straße 1<br/>
      A-6020 Innsbruck<br/>
      Austria<br/>
    </p>
    <h3>Contakt</h3>
    <p>
      Assoz.-Prof. Dr. Markus A. Keller<br/>
      phone: +43 512 9003 70550<br/>
      mail: biochemgen@i-med.ac.at<br/>
      homepage: <a href="biochemgen.at">biochemgen.at</a><br/>
    </p>
    <h3>Disclaimer</h3>
    <p>
      The contents of this website have been created with the utmost care.
      However, we cannot guarantee the accuracy, completeness, or timeliness of the information provided.
      This website is intended for scientific information and exchange.
      Links to external websites have been carefully reviewed; however, we assume no responsibility for their content.
    </p>
  <h3>Copyright:</h3>
    <p>
      The content generated by this web server is licensed under the Creative Commons Attribution 4.0 International (CC BY 4.0).
      You are allowed to copy, distribute, modify, and use the generated analyses and visualizations for commercial purposes, provided that appropriate attribution is given.
    </p>
    <h2>Impressum</h2>
    <h3>Betreiber der Website:</h3>
    <p>
      Medizinische Universität Innsbruck <br/>
      Institut für Humangenetik<br/>
      Biochemische Genetik<br/>
      Peter-Mayr-Straße 1<br/>
      A-6020 Innsbruck<br/>
      Austria<br/>
    </p>
    <h3>Kontakt</h3>
    <p>
      Assoz.-Prof. Dr. Markus A. Keller<br/>
      Telefon: +43 512 9003 70550<br/>
      Email: biochemgen@i-med.ac.at<br/>
      Website: <a href="biochemgen.at">biochemgen.at</a><br/>
    </p>

    <h3>Haftungsausschluss</h3>
    <p>Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. 
      Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
      Diese Website dient der wissenschaftlichen Information und dem Austausch. 
      Links zu externen Websites wurden sorgfältig geprüft, dennoch übernehmen wir keine Verantwortung für deren Inhalte.
    </p>

  <h3>Copyright:</h3>
    <p>
      Die durch diesen Webserver generierten Inhalte stehen unter der Creative Commons Attribution 4.0 International (CC BY 4.0).
      Sie dürfen die generierten Analysen und Visualisierungen kopieren, verbreiten, verändern und für kommerzielle Zwecke nutzen, sofern eine angemessene Zitation erfolgt.
    </p>
  </div>
)
